import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
export const CommonStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      height: "auto",
      padding: "24px",
      borderRadius: "20px",
      border: "1px solid #F5F3EF",
      backgroundColor: "#FFF",
      [theme.breakpoints.down("sm")]: {
        padding: "16px",
      },
    },
  }),
);
